import api from './api';

export const savePushNotificationDeviceToken = async (pushNotificationDeviceToken: string) => {
  return await api.post('/notifications/addToken', { token: pushNotificationDeviceToken });
};
